
export default {

  SET_ACTIVITY_CONFIGURATIONS: (state, payload) => state.activityConfigurations = payload,

}